import React, { useState, useRef, useEffect, useContext } from "react";
import moment from "moment";
import 'moment/locale/th'
import { Modal, Button } from 'react-bootstrap';
import { AppContext } from "../context/ContextProvider";

const SelectDateConfirmModal = ({ show, onHide = () => { }, onConfirm = () => { }, start_date, end_date }) => {
  const { currentHotel, getBookingCartData, handleSetBookingCartData } = useContext(AppContext);
  const bookingCartData = getBookingCartData();

  return (
    <>
      <Modal size="md" show={show} onHide={onHide} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>ยืนยันการเลือกวันเข้าพัก</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* ขีดเส้นใต้ */}
          <p className="mb-2 text-danger">วันเข้าพักที่ท่านเลือกใหม่ <span className="underline " style={{fontWeight: 'bold', textDecoration: 'underline'}}>ไม่ตรงกับวันเข้าพักที่เพิ่มก่อนหน้า</span> ท่านต้องการเลือกวันเข้าพักนี้หรือไม่?</p>
          <div> 
            <p className="mb-0 text-black">วันเข้าพักที่เลือกก่อนหน้า : {moment(bookingCartData?.start_date).format('DD/MM/YYYY')} - {moment(bookingCartData?.end_date).format('DD/MM/YYYY')}</p>
            <p className="text-black">วันเข้าพักที่เลือกใหม่ : {moment(start_date).format('DD/MM/YYYY')} - {moment(end_date).format('DD/MM/YYYY')}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="warning" onClick={() => {
            onConfirm('cart');
            onHide();
          }}>ใช้วันเข้าพักก่อนหน้า</Button>
          <Button variant="primary" onClick={() => {
            onConfirm('selected');
            onHide();
          }}>ยืนยันเลือกวันเข้าพักใหม่</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SelectDateConfirmModal;
